import styled from 'styled-components';

import { TextInput } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

const InputHeight = 34;

export const InputWithLabelSeparator = styled.div`
  width: 1px;
  height: 100%;
  background: ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};

  &[data-disabled='true'] {
    background: ${ct({ Light: Colors.Grey, Dark: Colors.Grey })};
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${ct({ Dark: Colors.Lighter, Light: Colors.Lighter })};
  min-width: unset;
  padding: 0 16px 0 12px;
  border-radius: 4px 0 0 4px;

  & p {
    color: ${ct({ Dark: Colors.Dark, Light: Colors.Dark })};
    font-weight: 500;
  }

  &[data-disabled='true'] p {
    color: ${ct({ Light: Colors.GreyDarkerMiddle, Dark: Colors.GreyDarkerMiddle })};
  }
`;

export const InputContainer = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
`;

export const TextInputStyled = styled(TextInput)`
  height: ${InputHeight}px;
  border: none;
  width: 100%;
  min-width: 80px;
`;

export const InputWithLabelStyled = styled.div`
  flex: 1;
  display: flex;
  height: ${InputHeight}px;
  border-radius: 4px;
  border: 1px solid ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
  max-width: 100%;

  &[data-disabled='true'] {
    border: 1px solid ${ct({ Light: Colors.Grey, Dark: Colors.Grey })};
  }
`;
